import React, { useState } from "react";
import toast from "react-hot-toast";
import Quote from "../components/Quote";
import html2pdf from "html2pdf.js";

const HLB = () => {
  const [Length, setLength] = useState(null);
  const [Breadth, setBreadth] = useState("");
  const [Gramage, setGramage] = useState("");
  const [Qty, setQty] = useState("");
  const [Wt, setWt] = useState(null);
  const [result, setResult] = useState(null);
  const [rate, setRate] = useState(89);

  const handleCalculate = () => {
    if (!Length || !Breadth || !Qty) {
      toast.error("Please fill out all required fields.");
      return;
    }

    if (!Gramage && !Wt) {
      toast.error("Please provide either Gramage or Weight.");
      return;
    }

    if (Gramage && Wt) {
      toast.error("Only one of Gramage or Weight should be provided.");
      return;
    }

    let calculatedWt = Wt;
    let calculatedGramage = Gramage;

    if (!Wt) {
      // Calculate Weight if Gramage is provided
      calculatedWt = (Length * Breadth * Gramage) / 3300;
    } else if (!Gramage) {
      // Calculate Gramage if Weight is provided
      calculatedGramage = (Wt * 3300) / (Length * Breadth);
    }
    const price = (calculatedWt / 1000) * rate;

    setResult({
      description: `HM LD Bag of (${Length}x${Breadth}x${Math.round(
        calculatedGramage
      )}GSM). Bag wt. Approx - ${calculatedWt.toFixed(2)} grams`,
      qty: parseFloat(Qty), // Ensures qty is a floating-point value
      weight: parseFloat(calculatedWt.toFixed(2)), // Total weight of the bags as a floating value
      price: parseFloat(price.toFixed(2)), // Total price as a floating value
    });
    console.log({
      description: `HM LD Bag of (${Length}x${Breadth}x${Math.round(
        calculatedGramage
      )}GSM). Bag wt. Approx - ${calculatedWt.toFixed(2)} grams ${
        calculatedWt <= 1000
          ? `- ${(1000 / calculatedWt).toFixed(2)} piece per KG`
          : ""
      }`,
      qty: parseFloat(Qty), // Ensures qty is a floating-point value
      weight: parseFloat(calculatedWt.toFixed(2)), // Total weight of the bags as a floating value
      price: parseFloat(price.toFixed(2)),
    });
  };

  const handleDownload = () => {
    // Select the HTML element to convert
    const element = document.getElementById("report");

    // Convert and download PDF
    const options = {
      margin: 1,
      filename: "Quote-GD.pdf",
      html2canvas: { scale: 2 },
      jsPDF: {
        orientation: "portrait", // Keeps the orientation as portrait
        unit: "mm", // Set units to millimeters for better precision
        format: "a4", // You can set other formats like "letter" if needed
        autoSize: true, // Automatically adjust size based on content
      },
    };

    html2pdf().set(options).from(element).save();
  };

  return (
    <div className="container">
      <div className="sv_section-title">
        <h2>HM LD Bag Cost</h2>
      </div>

      <div className="row justify-content-center">
        <div className="box-calculator">
          {/* Input Fields */}
          <div className="form-group-row">
            <div className="form-group">
              <label>Length:</label>
              <input
                type="number"
                value={Length ?? ""}
                placeholder="Length in inch"
                onChange={(e) => setLength(parseFloat(e.target.value) || null)}
              />
            </div>

            <div className="form-group">
              <label>Breadth:</label>
              <input
                type="number"
                value={Breadth}
                placeholder="Breadth in inch"
                onChange={(e) => setBreadth(e.target.value)}
              />
            </div>

            <div className="form-group">
              <label>Gramage [GSM]:</label>
              <input
                type="number"
                value={Gramage}
                placeholder="Gramage"
                onChange={(e) => setGramage(e.target.value)}
              />
            </div>
          </div>

          <div className="form-group-row">
            <div className="form-group">
              <label>Quantity:</label>
              <input
                type="number"
                value={Qty}
                placeholder="Quantity"
                onChange={(e) => setQty(e.target.value)}
              />
            </div>

            <div className="form-group">
              <label>Wt.:</label>
              <input
                type="number"
                value={Wt ?? ""}
                placeholder="Weight in grams"
                onChange={(e) => setWt(parseFloat(e.target.value) || null)}
              />
            </div>
            <div className="form-group">
              <label>Rate:</label>
              <input
                type="number"
                value={rate}
                placeholder="rate"
                onChange={(e) => setRate(e.target.value)}
              />
            </div>
          </div>

          {/* Calculate Button */}
          <button
            onClick={handleCalculate}
            className="btn-primary w-100 mt-3 mb-3"
          >
            Calculate
          </button>

          {/* Results */}
          {result && (
            <div>
              {/* Download PDF Button */}
              <button
                onClick={handleDownload}
                className="btn-primary w-100 mt-3 mb-3"
              >
                Download PDF
              </button>

              {/* Quote Section */}
              <div style={{ marginTop: "20px" }}>
                <Quote
                  description={result.description}
                  qty={result.qty}
                  rate={result.price}
                  weightAfterWastage={result.weight}
                  type="Bag"
                />
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default HLB;
